import http from "@/http/aisea/axios";

export default {
  async getVessels({ commit }) {
    const res = await http.get(`/enterprise/vessels/search`, {
      params: { limit: 9999 },
    });
    if (!res || !res.data) return [];
    const vessels = res.data.vessels.map(item => {
      return {
        label: item.name_ja ? item.name_ja : item.name,
        vessel_id: item.id,
      };
    });

    commit("SET_VESSELS", vessels);
  },
};
